<template>
    <div>
        <LoginControl
            v-if="renderok"
            :login="login"
            :lastupdated="lastupdated"
        ></LoginControl>
        <v-container style="height: 300px;" v-else-if="!renderok">
            <v-row
                class="fill-height"
                align-content="center"
                justify="center"
            >
                <v-col cols="6">
                    <v-progress-circular
                        :size="50"
                        color="#977EBE"
                        indeterminate
                    ></v-progress-circular> 
                </v-col>
            </v-row>
        </v-container>
        <v-snackbar
            v-model="snackbar"
            :color="snackbarcolor"
            :timeout="timeout"
        >
            {{ text }}
        </v-snackbar>
    </div>
</template>
<script>
import LoginControl from "./LoginControl.vue"

export default {
    components: {
        LoginControl
    },
    data(){
        return {
            host: location.hostname.toString(),
            renderok: false,
            login: "",
            lastupdated: "",
            snackbar: false,
            snackbarcolor: "",
            text: "",
            timeout: 3500
        }
    },
    methods: {
        getConfiguration(){
            const that = this;
            let api= 'https://'+that.host+'/cgi-bin/sfs-portal-api/api.py?adminConfigGet';

            //API GET request
            fetch(api)
                .then(function (response) {
                    return response.json();
                })
                .then(function (resultData) {
                    if(!resultData.result.match(/OK/i)){
                        that.setSnackbar("Warning: "+resultData.message, "#FFCC80"); //orange
                    }
                    if(resultData.data){
                        that.login = resultData.data.login;

                        that.lastupdated = resultData.data.lastUpdatedDateTime;

                        that.renderok = true;
                    }
                })
                .catch(function(err){
                    that.setSnackbar("Error: "+err.toString(), "#E57373"); //light red
                })
            //End of API GET request
        },
        setSnackbar(msg, color){ //Sets Snackbar
            const that = this;
            that.snackbar = true;
            that.snackbarcolor = color;
            that.text = msg;
        }
    },
    created(){
        const that = this;
        that.getConfiguration();
    }
}
</script>